import type { FC } from "react";
import * as CSS from "./tabs.styles";
import type { TabProps } from "./tabs.types";

type TabsProps = {
	items: Omit<TabProps, "isActive">[];
	activeTab: string;
	onChange: (id: string) => void;
};

const Tabs: FC<TabsProps> = ({ items, activeTab, onChange }) => {
	return (
		<CSS.TabContainer>
			{items.map((tabItem) => (
				<CSS.Tab
					key={tabItem.id}
					$active={tabItem.id === activeTab}
					$width={100 / items.length}
					role="button"
					onClick={() => onChange(tabItem.id)}
					disabled={!!tabItem.disabled}
				>
					{tabItem.label}
				</CSS.Tab>
			))}
		</CSS.TabContainer>
	);
};

export default Tabs;
